import { render, staticRenderFns } from "./AromaTabbar.vue?vue&type=template&id=9180ca2e&scoped=true"
import script from "./AromaTabbar.vue?vue&type=script&lang=js"
export * from "./AromaTabbar.vue?vue&type=script&lang=js"
import style0 from "./AromaTabbar.vue?vue&type=style&index=0&id=9180ca2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9180ca2e",
  null
  
)

export default component.exports